import React from 'react';
import {
    ChallengeLeaderboardProps,
    LeaderboardEntry,
    getRankIcon,
    formatProgress,
    formatLeaderboardValue,
} from '@fitzaa/shared';

export const ChallengeLeaderboard: React.FC<ChallengeLeaderboardProps> = ({
    challengeId,
    challengeTitle,
    entries,
    currentUserId,
    onClose,
}) => {
    return (
        <div className="flex-1 bg-gray-50">
            {/* Header */}
            <div className="p-5 bg-white border-b border-gray-200">
                <h1 className="text-2xl font-bold text-gray-900 mb-1">Leaderboard</h1>
                <p className="text-base text-gray-600">{challengeTitle}</p>
            </div>

            {/* Leaderboard List */}
            <div className="flex-1 overflow-y-auto">
                {entries.map((entry) => (
                    <div
                        key={entry.userId}
                        className={`flex items-center p-4 bg-white border-b border-gray-100 ${entry.userId === currentUserId ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''
                            }`}
                    >
                        {/* Rank */}
                        <div className="w-12 text-center">
                            <span className={`font-bold ${entry.rank <= 3 ? 'text-2xl' : 'text-lg text-gray-600'
                                }`}>
                                {getRankIcon(entry.rank)}
                            </span>
                        </div>

                        {/* User Info */}
                        <div className="flex-1 ml-3">
                            <div className="font-semibold text-gray-900">{entry.displayName}</div>
                            {entry.organizationName && (
                                <div className="text-xs text-gray-600">{entry.organizationName}</div>
                            )}
                            {entry.teamName && (
                                <div className="text-xs text-gray-600">{entry.teamName}</div>
                            )}
                        </div>

                        {/* Progress */}
                        <div className="text-right mr-3">
                            <div className="font-bold text-green-600">{formatProgress(entry.totalProgress)}</div>
                            <div className="text-xs text-gray-600">{formatLeaderboardValue(entry.totalValue, entry.targetValue)}</div>
                        </div>

                        {/* Points */}
                        <div className="text-center min-w-[60px]">
                            <div className="font-bold text-yellow-600">{entry.pointsEarned}</div>
                            <div className="text-xs text-gray-600 uppercase">pts</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Close Button */}
            <div className="p-5 bg-white border-t border-gray-200">
                <button
                    className="w-full text-center font-semibold text-blue-600 py-3"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </div>
    );
}; 